import { BasicTextField } from '../BasicTextField/BasicTextField'

import type { FormFieldWrapper } from '@ngb-frontend/shared/types'

export const CityField: React.FC<FormFieldWrapper> = (props) => (
  <BasicTextField {...props} field="city" labelKey="fields.city.label" />
)
